// Fehlergrenze um den Seiteninhalt.
//
// Ohne sie wirft React bei einem Render-Fehler den KOMPLETTEN Baum weg:
// weisse Seite, keine Seitenleiste, kein Hinweis. Genau so sah die Leadliste
// aus, als ein einzelner Datensatz mit einer Zahl im Namensfeld drin war.
// Mit Grenze bleibt die Navigation stehen, und der Fehler steht lesbar da —
// mitsamt Text, den man dem Support schicken kann.
import { Component } from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default class Fehlergrenze extends Component {
  state = { fehler: null };

  static getDerivedStateFromError(fehler) {
    return { fehler };
  }

  componentDidCatch(fehler, info) {
    // Konsole, damit der Stack im Browser bleibt (Support / Fehlersuche)
    console.error('Seite konnte nicht gerendert werden:', fehler, info?.componentStack);
  }

  componentDidUpdate(vorher) {
    // Neue Route = neuer Versuch. Sonst bliebe die Meldung an jeder Seite kleben.
    if (this.state.fehler && vorher.pfad !== this.props.pfad) {
      this.setState({ fehler: null });
    }
  }

  render() {
    const { fehler } = this.state;
    if (!fehler) return this.props.children;
    return (
      <div className="max-w-xl mx-auto mt-16 p-6 rounded-xl border border-destructive/40 bg-destructive/5 space-y-4"
           data-testid="fehlergrenze">
        <div className="flex items-center gap-2 text-destructive font-semibold">
          <AlertTriangle className="w-5 h-5" /> Diese Seite konnte nicht angezeigt werden
        </div>
        <p className="text-sm text-muted-foreground">
          Meist steckt ein einzelner Datensatz mit einem unerwarteten Wert dahinter.
          Die übrigen Seiten funktionieren weiter — bitte den Fehlertext an den Support geben.
        </p>
        <pre className="text-xs bg-muted rounded-md p-3 overflow-x-auto whitespace-pre-wrap"
             data-testid="fehlergrenze-text">{String(fehler?.message || fehler)}</pre>
        <Button size="sm" variant="outline" className="gap-1.5" onClick={() => window.location.reload()}>
          <RefreshCw className="w-3.5 h-3.5" /> Seite neu laden
        </Button>
      </div>
    );
  }
}
